export default __webpack_public_path__ + "static/media/instagram-2016.6a8a0053.svg";